<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="mainwrap">
      <div class="container">
        <div class="submain">
          <div class="titleA"><strong>{{ pageContent.title }}</strong></div>
          <div style="font-size:22px;font-weight: bold;">博奥润康(许昌)医学检验实验室</div>
          <div v-if="pageContent" v-html="pageContent.content"></div>
          <div v-else>
            <p>页面暂无内容</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageApi } from '@/api'

export default {
  name: 'Contact',
  data() {
    return {
      pageContent: ''
    }
  },
  mounted() {
    // 使用固定的ID查询，例如ID为1的页面
    this.fetchAboutPage(2)
  },
  methods: {
    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;

  .subbanner {
    background-size: 100% 100%;

    .title {
      font-size: 50px;
      letter-spacing: 0px;
      line-height: 32px;
    }

    span {
      position: relative;
      font-size: 30px;
      font-family: 'Times New Roman', Times, serif;
    }
  }


  img {
    max-width: 80%;
  }


}

// 移动端适配样式
@media (max-width: 768px) {
  .subcontent {
    font-size: 1rem;
    line-height: 1.6;

    .subbanner {
      
      .container {
        padding-left: 1rem !important;
      }

      .title {
        font-size: 1.8rem !important;
      }

      span {
        font-size: 1.1rem !important;
      }
    }


    .submain {
      padding: 1rem 0 !important;

      > div {
        &:first-child {
          font-size: 1.2rem !important;
        }
      }

      p {
        font-size: 0.9rem !important;
        line-height: 1.7 !important;
        margin: 1rem 0 !important;
      }
    }
  }
}
</style>